var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseTableList',{staticClass:"cooperates-table",attrs:{"table-set-list":_vm.cooperatelist,"display-items":_vm.cooperates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }